import React, { useState, useEffect, useRef } from "react";
import { locations, Location } from "../data/locations";

interface LocationSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const LocationSelect: React.FC<LocationSelectProps> = ({
  value,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(value);
  const [filteredLocations, setFilteredLocations] =
    useState<Location[]>(locations);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const filtered = locations.filter((location) =>
      `${location.city}, ${location.stateCode}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
    setFilteredLocations(filtered);
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (location: Location) => {
    const locationString = `${location.city}, ${location.stateCode}`;
    onChange(locationString);
    setSearchTerm(locationString);
    setIsOpen(false);
  };

  return (
    <div className="position-relative" ref={dropdownRef}>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="Enter city, state..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            if (!e.target.value) {
              onChange(e.target.value);
            }
          }}
          onFocus={() => setIsOpen(true)}
        />
      </div>

      {isOpen && (
        <div
          className="position-absolute w-100 mt-1 bg-white border rounded shadow-sm"
          style={{ maxHeight: "300px", overflowY: "auto", zIndex: 1000 }}
        >
          {filteredLocations.map((location) => (
            <div
              key={`${location.city}-${location.stateCode}`}
              className="p-2 cursor-pointer hover:bg-light"
              onClick={() => handleSelect(location)}
            >
              {location.city}, {location.stateCode}
            </div>
          ))}
          {filteredLocations.length === 0 && (
            <div className="p-2 text-muted">No locations found</div>
          )}
        </div>
      )}
    </div>
  );
};
